import api from '@/plugins/request/index';

// 跟进-日志列表
export const followLogList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/log/follow`, params).then(res => res);
}
// 跟进列表-导出
export const exportFollowList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/log/follow/export`, params).then(res => res);
}
// 跟进列表-选择级联跟进方式
export const exportFollowWayList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/log/follow/search-type-tree`, params).then(res => res);
}
// 商机-获取列表
export const getBussinessList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/business`, params).then(res => res);
}
// 商机-修改商机状态
export const bussChangeStatus = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/business/${id}/change-status`, params).then(res => res);
}
// 商机-获取商机详情
export const getBussinessById = async (id, type = 'get') => {
  return api[type](`/gateway/v1/business/${id}`).then(res => res);
}
// 商机-旅程列表
export const getBussGurneyList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/log/business-route-logs`, params).then(res => res);
}
// 商机-旅程操作人列表
export const getBussGurneyAdmin = async (params, type = 'get') => {
  return api[type](`/gateway/v1/log/business-route-operators`, params).then(res => res);
}
// 商机-写跟进
export const bussFollowAdd = async (params, type = 'post') => {
  return api[type](`/gateway/v1/business/${params.id}/follow`, params).then(res => res);
} 
// 订单-列表接口
export const getOrderList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/order`, params).then(res => res);
}
// 订单-列表接口导出
export const orderListExport = async (params, type = 'get') => {
  return api[type](`/gateway/v1/order/export`, params).then(res => res);
}
// 订单-获取订单详情
export const getOrderDetail = async (id, type = 'get') => {
  return api[type](`/gateway/v1/order/${id}`).then(res => res);
}
// 订单-申请退款
export const applyRefuse = async (params, type = 'post') => {
  return api[type](`/gateway/v1/approval/apply-refund`, params).then(res => res);
}
// 订单-申请结佣
export const applyCommission = async (params, type = 'post') => {
  return api[type](`/gateway/v1/approval/apply-settlement`, params).then(res => res);
}
// 订单-申请签约
export const applySign = async (params, type = 'post') => {
  return api[type](`/gateway/v1/approval/apply-sign`, params).then(res => res);
}
// 订单-跟进
export const orderFollowAdd = async (params, type = 'post') => {
  return api[type](`/gateway/v1/order/${params.id}/follow`, params).then(res => res);
}
// 订单-旅程跟进人列表
export const getOrderGurneyAdmin = async (params, type = 'get') => {
  return api[type](`/gateway/v1/log/order-route-operators`, params).then(res => res);
}
// 订单-旅程列表
export const getOrderGurneyList = async (params, type = 'get') => {
  return api[type](`/gateway/v1/log/order-route-logs`, params).then(res => res);
}